
<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">
            <!-- <span>flowtrics</span> -->
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    
    <div class="Wrapper">
        <h3>We are sorry to inform you that you do not eligible to submit this form. For further assistance, please contact your coordinator.</h3>
        <!-- <h5>Once all parties have signed, you'll be emailed a copy.</h5> -->
        <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div>
        <!-- <a class="register" href="http://flowtrics.com/"  mat-stroked-button color="primary"  type="button">Get Started</a> -->
    </div> 
</div>


